<div class="container-fluid page">
  <div class="d-flex align-items-center mb-3" style="gap: 20px">
    <span [routerLink]="['/user-management/role/list']" class="go-back">
      <img src="assets/images/arrow-left.svg" alt="arrow-left" />Roles List
    </span>
    <img src="assets/images/arrow-right.svg" alt="arrow-right" />
    <ng-container *ngIf="!isEdit">Add</ng-container>
    <ng-container *ngIf="isEdit">Edit</ng-container> Role
  </div>
  <mat-card class="p-0">
    <form class="mat-form" [formGroup]="upsertRoleFrom">
      <mat-tab-group
        class="role-tab"
        [selectedIndex]="selectedIndex"
        (selectedTabChange)="tabClick($event)">
        <mat-tab label="Role Info">
          <div class="container-fluid">
            <div class="row mt-3">
              <div class="col-md-6 form-group">
                <app-input-template
                  [inputData]="attrConstant.name"
                  [formControlName]="
                    attrConstant.name.key
                  "></app-input-template>
              </div>
              <div class="col-md-6 form-group">
                <app-input-select
                  [inputData]="attrConstant.roleType"
                  [selectOptions]="roleType"
                  [bindLabel]="'label'"
                  [bindValue]="'value'"
                  [formControlName]="
                    attrConstant.roleType.key
                  "></app-input-select>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-6 form-group">
                <app-input-template
                  [inputData]="attrConstant.slug"
                  [formControlName]="
                    attrConstant.slug.key
                  "></app-input-template>
              </div>
              <div class="col-md-6 form-group">
                <app-input-template
                  [inputData]="attrConstant.description"
                  [formControlName]="
                    attrConstant.description.key
                  "></app-input-template>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Assign Permission" [disabled]="selectedIndex === 0">
          <mat-card
            class="px-4 m-3"
            *ngFor="let data of permissionList; let i = index"
            style="height: fit-content">
            <h2
              *ngIf="data.permissions && data.permissions.length > 0"
              class="permission-group">
              <!-- <mat-checkbox (change)="onChangeSection($event)" [value]="data.permission_section_id" [checked]="data.isChecked"> -->
              {{ data.name }}
              <!-- </mat-checkbox> -->
            </h2>
            <mat-checkbox
              class="ps-0 py-2 pe-3"
              *ngFor="let permission of data.permissions; let i = index"
              (change)="onChange($event, data)"
              [value]="permission.permission_id"
              [checked]="permission.isChecked">
              {{ permission.title }}
            </mat-checkbox>
          </mat-card>
        </mat-tab>
      </mat-tab-group>
    </form>
  </mat-card>
  <div class="row my-3">
    <div class="col-md-12 text-center button-wrap">
      <ng-container *ngIf="selectedIndex === 0">
        <button
          mat-raised-button
          (click)="nextStep()"
          class="me-3"
          [disabled]="isButtonDisabled">
          Next
        </button>
        <button mat-raised-button routerLink="/user-management/role/list">
          Cancel
        </button>
      </ng-container>
      <button
        mat-raised-button
        class="w-100"
        *ngIf="selectedIndex === 1"
        (click)="onUpsertRole()">
        Submit
      </button>
    </div>
  </div>
</div>
